import { useEffect } from "react";
import { applyPageSeo, notFoundSeo } from "./seo.js";

export default function NotFoundPage() {
  useEffect(() => { applyPageSeo(notFoundSeo); }, []);
  return <main className="mp-crash"><a href="/" aria-label="PuntoPY, inicio"><img src="/brand/puntopy-logo-horizontal.svg" alt="PuntoPY" /></a><h1>No encontramos esta página</h1><p>El enlace puede haber cambiado. Podés volver al buscador para explorar productos y comercios.</p><a className="mp-button primary" href="/">Volver a PuntoPY</a></main>;
}
